import { useEffect } from 'react';
import { connect } from 'react-redux';
import Cookies from 'js-cookie';
// import { getCustomId } from 'app/libs/core/Unique';
import userAPI from '../../../API/user.service.api';
import { GUEST_FE_USER_HISTORY_IDENTIFIER } from '../../../constants/user.constants';

export const KeepFeUserHistoryForGuests = (props) => {
  const getGuestId = () => Cookies.get(GUEST_FE_USER_HISTORY_IDENTIFIER);

  const saveGuestHistoryToCurrentUser = () => {
    const guestId = getGuestId();
    const { id = 0 } = props.user;
    if (guestId && id) {
      userAPI
        .setGuestHistoryToCurrentUser(guestId, id)
        .then(
          (res) =>
            res.code === 200 && Cookies.remove(GUEST_FE_USER_HISTORY_IDENTIFIER)
        )
        .catch((err) => console.log(err));
    }
  };

  useEffect(() => {
    if (props.isLogin) {
      saveGuestHistoryToCurrentUser();
    }
  }, [props.isLogin]);

  return '';
};

const mapStateToProps = (state) => ({
  isLogin: state.authentication.isLoggedIn,
  user: state.authentication.user,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(KeepFeUserHistoryForGuests);
